<div class="card form-card">
	<!-- Header -->
	<!-- <div class="card-header">
        <h3>Institute Details</h3>
        <p>Fill in the institute information below.</p>
    </div> -->

	<!-- Body -->
	<div class="card-body p-4">
		<!-- <div class="col-md-12 mb-2" *ngIf="!loading && orgs && orgs.length>0">
			<label class="form-label">
				Organization <span class="required">*</span>
			</label>
			<select class="form-select" [(ngModel)]="frmData.org_id" [disabled]="isReadonly">
				<option selected disabled>
					Select Organization
				</option>
				@for(o of orgs; track $index) {
				<option value="{{o.id}}">{{o.org_name}}</option>
				}
			</select>
		</div> -->


		<!-- Basic Information -->
		<div class="section-title">
			<i class="bi bi-person-vcard-fill"></i>
			Basic Information {{isReadonly}}
		</div>

		<div class="row g-3">
			<div class="col-md-6">
				<label class="form-label">
					Institute Name
					<span class="required">*</span>
				</label>
				<input type="text" class="form-control" [(ngModel)]="frmData.inst_name" placeholder="Enter institute name"
					[disabled]="isReadonly || isEdit">
			</div>

			<div class="col-md-6">
				<label class="form-label">
					Institute Type
					<span class="required">*</span>
				</label>
				<select class="form-select" [(ngModel)]="frmData.inst_type" [disabled]="isReadonly">
					<option selected disabled>
						Select Institute Type
					</option>
					@for(it of dataService.institute_types; track $index;) {
					<option value="{{it.code}}">{{it.name}}</option>
					}
				</select>
			</div>

			<div class="col-md-6">
				<label class="form-label">
					Website
				</label>
				<input type="url" class="form-control" [(ngModel)]="frmData.website" placeholder="https://www.example.com"
					[disabled]="isReadonly">
			</div>

			<div class="col-md-6">
				<label class="form-label">
					Registration No.
				</label>
				<input type="text" class="form-control" [(ngModel)]="frmData.reg_no" placeholder="Enter registration number"
					[disabled]="isReadonly">
			</div>

			<div class="col-md-6">
				<label class="form-label">
					GST No.
				</label>
				<input type="text" class="form-control" [(ngModel)]="frmData.gst_no" placeholder="GST Number"
					[disabled]="isReadonly">
			</div>

			<div class="col-md-6">
				<label class="form-label">
					Phone Number
					<span class="required">*</span>
				</label>
				<input type="tel" class="form-control" [(ngModel)]="frmData.phone_no" placeholder="9876543210"
					[disabled]="isReadonly">
			</div>
		</div>

		<!-- Images -->
		<div class="section-title mt-5">
			<i class="bi bi-substack"></i>
			Institute Branding
		</div>

		<div class="row g-4">
			<div class="col-md-6">
				<label class="form-label">
					Logo Image
				</label>

				<div class="upload-box">
					<input class="form-control" type="file" accept="image/*" id="logo-file" 
						(change)="onLogoSelected($event)">
					<div class="preview-box mt-3 flex-column">
						<ng-container *ngIf="lImgPreview">
							<div style="width: 95%; text-align: end; margin-top: -20px;">
								<i class="bi bi-x-circle-fill text-danger" style="cursor: pointer;" (click)="removeLogo()"></i>
							</div>
							<img [src]="lImgPreview" alt="Logo Preview" style="width: 80%; max-height: 90%; margin-top: -5px;" />
						</ng-container>
						<span *ngIf="!lImgPreview">Logo Preview</span>
					</div>
				</div>
			</div>

			<div class="col-md-6">
				<label class="form-label">
					Banner Image
				</label>

				<div class="upload-box">
					<input class="form-control" type="file" accept="image/*" id="bnr-file" 
						(change)="onBnrSelected($event)">
					<div class="preview-box mt-3 flex-column">
						<ng-container *ngIf="bImgPreview">
							<div style="width: 95%; text-align: end; margin-top: -20px;">
								<i class="bi bi-x-circle-fill text-danger" style="cursor: pointer;" (click)="removeBnr()"></i>
							</div>
							<img [src]="bImgPreview" alt="Logo Preview" style="width: 80%; max-height: 90%; margin-top: -5px;" />
						</ng-container>
						<span *ngIf="!bImgPreview">Banner Preview</span>
					</div>
				</div>
			</div>
		</div>

		<!-- Address -->
		<div class="section-title mt-5">
			<i class="bi bi-geo-alt-fill"></i>
			Address Information
		</div>

		<div class="row g-3">
			<div class="col-md-8">
				<label class="form-label">Address</label>
				<textarea class="form-control " rows="5" [(ngModel)]="frmData.address" [disabled]="isReadonly"></textarea>
			</div>
			<div class="col-md-4">
				<label class="form-label">State/City/Pincode</label>
				<div class="mb-2">
					<!-- <label class="form-label">
                        State
                    </label> -->
					<select class="form-select" [(ngModel)]="frmData.state" [disabled]="isReadonly"
						(change)="districts = dataService.getDist(frmData.state)">
						<option>Select State</option>
						@for(st of dataService.cityDataDD; track $index) {
						<option>{{st.state}}</option>
						}
					</select>
				</div>
				<div class="mb-2">
					<!-- <label class="form-label">
                        City
                    </label> -->
					<select class="form-select" [(ngModel)]="frmData.city" [disabled]="isReadonly">
						<option>Select City</option>
						@for(dist of districts; track $index) {
						<option>{{dist}}</option>
						}
					</select>
				</div>
				<input type="tel" class="form-control" [(ngModel)]="frmData.pincode" placeholder="Pincode"
					[disabled]="isReadonly">
			</div>
		</div>

	</div>
</div>